import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Flag from "src/app/components/Flag/Flag";
import { countryData } from "src/utils/countryData";

export const getCountryOptions = () => {
  return countryData.map((option) => ({
    label: (
      <div className="trial-page-right__country-option">
        <Flag countryCode={option.code} />
        <span className="trial-page-right__country-option-name">
          {option.name}
        </span>
      </div>
    ),
    value: option.name,
    code: option.code,
  }));
};

export const getPhoneNumberPrefixBaseOnCountryCode = (code) =>
  countryData.find((data) => data.code === code).dialling_code;

export const useSoftwareAsOptions = [
  {
    label: <IDHFormattedMessage id="ws_agency" defaultMessage="Agency" />,
    value: "ws_agency",
  },
  {
    label: (
      <IDHFormattedMessage id="ws_local_brand" defaultMessage="Local Brand" />
    ),
    value: "ws_local_brand",
  },
  {
    label: (
      <IDHFormattedMessage id="ws_global_brand" defaultMessage="Global Brand" />
    ),
    value: "ws_global_brand",
  },
  {
    label: (
      <IDHFormattedMessage id="ws_media_owner" defaultMessage="Media Owner" />
    ),
    value: "ws_media_owner",
  },
  {
    label: <IDHFormattedMessage id="ws_ecommerce" defaultMessage="eCommerce" />,
    value: "ws_ecommerce",
  },
  {
    label: <IDHFormattedMessage id="ws_startup" defaultMessage="Startup" />,
    value: "ws_startup",
  },
  {
    label: (
      <IDHFormattedMessage id="ws_university" defaultMessage="University" />
    ),
    value: "ws_university",
  },
];

export const marketOptions = [
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_poland"
        defaultMessage="(PL) Poland"
      />
    ),
    value: "PL",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_europe"
        defaultMessage="(EU) Europe"
      />
    ),
    value: "EU",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_united_kingdom"
        defaultMessage="(UK) United Kingdom"
      />
    ),
    value: "UK",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_japan_and_asia_pacific"
        defaultMessage="(JAPAC) Japan and Asia"
      />
    ),
    value: "JAPAC",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_africa"
        defaultMessage="(AF) Africa"
      />
    ),
    value: "AF",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_middle_east_and_north_africa"
        defaultMessage="(MENA) Middle East and North Africa"
      />
    ),
    value: "MENA",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_north_america"
        defaultMessage="(NA) North America"
      />
    ),
    value: "NA",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_latin_america"
        defaultMessage="(LATAM) Latin America"
      />
    ),
    value: "LATAM",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_select_market_india"
        defaultMessage="(IN) India"
      />
    ),
    value: "IN",
  },
  {
    label: (
      <IDHFormattedMessage id="ws_select_market_other" defaultMessage="Other" />
    ),
    value: "other",
  },
];

export const needAssistanceInOptions = [
  {
    label: (
      <IDHFormattedMessage
        id="ws_finding_creators"
        defaultMessage="Finding Creators"
      />
    ),
    value: "ws_finding_creators",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_evaluating_creators"
        defaultMessage="Evaluating Creators"
      />
    ),
    value: "ws_evaluating_creators",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_managing_influencer_campaigns"
        defaultMessage="Managing Influencer Campaigns, Teams & Tasks"
      />
    ),
    value: "ws_managing_influencer_campaigns",
  },
  {
    label: (
      <IDHFormattedMessage
        id="ws_generating_reports"
        defaultMessage="Generating Reports on Creators and Campaigns"
      />
    ),
    value: "ws_generating_reports",
  },
  {
    label: <IDHFormattedMessage id="ws_other" defaultMessage="Other" />,
    value: "other",
  },
];

export const isBusinessEmailMatchingWebsiteDomain = (email, website) => {
  const emailDomain = email.match(/@(.+)/);

  const websiteDomain = website.match(
    /^(?:https?:\/\/)?(?:www\.)?(.+?)(?:\/|$)/i,
  );

  return (
    emailDomain &&
    websiteDomain &&
    emailDomain[1].toLowerCase() === websiteDomain[1].toLowerCase()
  );
};

export const formatPhoneNumber = (phoneNumber) => {
  const strippedNumber = phoneNumber.replace(/[^\d ]/g, "");

  const formattedNumber = strippedNumber.replace(/(\d{3})(?=\d)/g, "$1 ");

  return formattedNumber;
};
